import { useMutation, useQueryClient } from "@tanstack/react-query";
import { importaTargetareLista } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useImportaTargetareLista() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importaTargetareLista,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.liste() });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
